<template>
  <div v-if="counters.length > 0" class="counter-select w-auto shrink-0">
    <Select
      :model-value="modelValue"
      :options="counterOptions"
      variant="ghost"
      size="sm"
      empty-value-to="null"
      @update:model-value="emit('update:modelValue', $event as string | null)"
    />
  </div>
</template>

<script setup lang="ts">
import Select from '@/components/Select.vue';
import type { StationCounter } from '@/entities/station/station.entity';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  counters: StationCounter[];
  modelValue: string | null | undefined;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | null): void;
}>();

const { t } = useI18n();

const counterOptions = computed(() => [
  { label: t('deliveryHandover'), value: null },
  ...props.counters.map((counter) => ({
    label: counter.name,
    value: counter.id,
  })),
]);
</script>

<i18n lang="json">
{
  "en": {
    "deliveryHandover": "Delivery handover (no counter)"
  },
  "de": {
    "deliveryHandover": "Lieferübergabe (ohne Schalter)"
  },
  "es": {
    "deliveryHandover": "Entrega a domicilio (sin mostrador)"
  }
}
</i18n>

<style scoped>
.counter-select :deep(label),
.counter-select :deep(select) {
  @apply w-auto;
}
</style>
